import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CollateralSkillSet } from '../collateralskillset.model';
import { CollateralskillsetsService } from '../collateralskillsets.service';

@Component({
  selector: 'app-collateralskillset-edit',
  templateUrl: './collateralskillset-edit.component.html',
  styleUrls: ['./collateralskillset-edit.component.css']
})
export class CollateralskillsetEditComponent implements OnInit {
    public editForm : FormGroup;
    public productSkillSets = [];
    constructor(public dialogRef: MatDialogRef<CollateralskillsetEditComponent>,
        @Inject(MAT_DIALOG_DATA) public skillset: CollateralSkillSet, public dialog: MatDialog,
        private collateralSkilSetService: CollateralskillsetsService, public fb: FormBuilder) {
        this.createForm();
    }

    ngOnInit() {
        this.getProductSkillset();
        this.editForm.controls.skillsetControl.setValue(this.skillset.name);
        this.editForm.controls.productSkillSetControl.setValue(this.skillset.productSkillsetId);
    }

    createForm() {
        this.editForm = this.fb.group({
            skillsetControl : ['', [Validators.required, Validators.maxLength(255)]],
            productSkillSetControl: [null, Validators.required]
        })
    }

    async getProductSkillset() {
        let result = await this.collateralSkilSetService.getProductSkillSet();
        this.productSkillSets = result;
    }

    async saveSkillset() {
        if (!this.editForm.valid) { 
            return;
        }
        const formModel = this.editForm.value;
        const updateSkillset: CollateralSkillSet = {
            id: this.skillset.id as string,
            name: formModel.skillsetControl as string,
            productSkillsetId: formModel.productSkillSetControl as string
        };

        let result = await this.collateralSkilSetService.updateSkillset(updateSkillset);
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/collateralskillset-edit/collateralskillset-edit.component.ts